import { makeProxyRequest } from '../utils/request';
import { aiInterviewV1, rpc } from './helper';
/**
 * Sets the user session configuration for Dhwani
 * @returns {Promise<{user_session_config_id: string, auth_token: string, connection_url: string}>}
 */
export const getDhwaniInterviewSession = payload =>
  makeProxyRequest(
    'post',
    aiInterviewV1(`/dhwani/interview-session`),
    true,
    payload
  );

/**
 * Validates the Dhwani interview session
 * @param {Object} payload - The payload for the API call
 * @returns {Promise<Object>} The validation response
 */
export const validateDhwaniInterviewSession = async payload => {
  return makeProxyRequest(
    'post',
    aiInterviewV1(`/dhwani/interview-session/validate`),
    true,
    payload
  );
};

/**
 * Uploads the candidate's CV for the Dhwani interview session
 * @param {Object} payload - The payload for the API call
 * @returns {Promise<Object>} The validation response
 */

export const uploadCandidateCV = payload =>
  makeProxyRequest('post', rpc(`/upload`), true, payload);

/**
 * Checks the status of CV question generation
 * @param {Object} payload - The payload for the API call
 * @returns {Promise<Object>} The validation response
 */

export const cvQuestionGenerationStatus = payload =>
  makeProxyRequest(
    'get',
    aiInterviewV1(
      `/cv-question-generation/status?test_solution_id=${payload.test_solution_id}`
    ),
    true
  );

/**
 * Checks the status of CV uploadad by candidate
 * @param {Object} payload - The payload for the API call
 * @returns {Promise<Object>} The validation response
 */

export const cvUploadStatus = payload =>
  makeProxyRequest(
    'get',
    aiInterviewV1(
      `/cv-upload/status?test_solution_id=${payload.testSolutionId}`,
      true
    )
  );
